import styled from 'styled-components';
import { colors, spacing, fontWeights } from 'ui/theme';
import { RightTooltip } from 'ui/tooltip';
import { CONTENT, PLATFORMS, COMPATIBILITY } from './constants';

const Container = styled.div`
  border-bottom: ${spacing.single} dotted ${colors.black};
  display: inline-block;
  position: relative;
`;

const ContentContainer = styled.div`
  padding-top: ${spacing.half};
`;

const StyledDT = styled.dt`
  font-weight: ${fontWeights.regular};
  margin-top: ${spacing.half};
`;

export const COMPATIBILITY_TOOLTIP_TEST_ID = 'compatibility-tool-tip';

export const CompatibilityTooltip = () => {
  return (
    <RightTooltip
      tooltipContent={
        <ContentContainer>
          {CONTENT.requires}
          <dl>
            <StyledDT>{CONTENT.heading[PLATFORMS.IOS]}</StyledDT>
            <dd>{COMPATIBILITY.iOS}</dd>
            <StyledDT>{CONTENT.heading[PLATFORMS.ANDROID]}</StyledDT>
            <dd>{COMPATIBILITY.android}</dd>
            <StyledDT>{CONTENT.heading[PLATFORMS.RN]}</StyledDT>
            <dd>{COMPATIBILITY.reactNative}</dd>
          </dl>
        </ContentContainer>
      }
    >
      <Container data-test={COMPATIBILITY_TOOLTIP_TEST_ID}>{CONTENT.hoverText}</Container>
    </RightTooltip>
  );
};
